module.exports = __webpack_public_path__ + "static/pranaa-color-min-891086b2c2154699ed5ca1a530daa947.jpeg";